"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _html2canvas = _interopRequireDefault(require("html2canvas"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _ = require('underscore');
var StartingHandChart = /*#__PURE__*/function (_React$Component) {
  _inherits(StartingHandChart, _React$Component);
  var _super = _createSuper(StartingHandChart);
  function StartingHandChart(props) {
    var _this;
    _classCallCheck(this, StartingHandChart);
    _this = _super.call(this, props);
    _this.tableData = function () {
      try {
        _this.setState({
          loading: true
        });
        var div = document.createElement('div');
        div.setAttribute("style", "opacity: 0.0;");
        div.setAttribute("id", "tbl");
        document.body.appendChild(div);
        document.getElementById("tbl").innerHTML = '<table id="handChart" class="table" style="width:320px;height:356px;margin:0;border: 1px solid white;border-collapse: collapse;">' + _.range(1, 13 + 1).map(function (r) {
          return '<tr>' + _this.displayCards(r).map(function (card) {
            return card;
          }) + '</tr>';
        }) + '</table>';
        var image = '';
        new Promise(function (resolve, reject) {
          (0, _html2canvas["default"])(document.getElementById('handChart')).then(function (canvas) {
            image = canvas.toDataURL("image/png");
            resolve();
          });
        }).then(function () {
          _this.setState({
            imageSrc: image
          });
          _this.forceUpdate();
          var removeDiv = document.getElementById('tbl');
          removeDiv.parentNode.removeChild(removeDiv);
          _this.setState({
            loading: false
          });
        });
      } catch (err) {
        throw new Error(err);
      }
    };
    _this.displayCards = function (r) {
      var rown = r,
        colN = 13,
        index = -1,
        cellVal = '',
        sameSuit = false,
        holeCards = _this.state.holeCards && Object.keys(_this.state.holeCards).length > 0 && _toConsumableArray(_this.state.holeCards),
        tdstyle = "border: 0.3px solid white;text-align:center;font-size:11px;\n                  padding:3px;vertical-align: middle;color:#1f1e23;font-weight:bold;",
        cells = [];
      if (_this.props.preFlopAggression) {
        cells = _.range(1, colN + 1).map(function (i) {
          var cards = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
          if (cards[i - 1] == cards[rown - 1]) {
            sameSuit = true;
            cellVal = cards[rown - 1] + '' + cards[i - 1];
          } else if (sameSuit) cellVal = cards[rown - 1] + '' + cards[i - 1] + "s";else cellVal = cards[i - 1] + '' + cards[rown - 1] + "o";
          var style = "background-color: #D8D8D8 ;".concat(tdstyle);
          index = _this.props.missionHands.findIndex(function (handObj) {
            return handObj.cards === cellVal;
          });
          if (_this.props.missionHands[index] && _this.props.missionHands[index].raised && _this.props.missionHands[index].raised === 1) style = "background-color: #8EC2FF; ".concat(tdstyle);else if (_this.props.missionHands[index] && _this.props.missionHands[index].limp && _this.props.missionHands[index].limp === 1) style = "background-color: #FFD500; ".concat(tdstyle);
          return '<td style="' + style + '">' + cellVal + '</td>';
        });
      } else {
        cells = _.range(1, colN + 1).map(function (i) {
          var cards = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
          if (cards[i - 1] == cards[rown - 1]) {
            sameSuit = true;
            cellVal = cards[rown - 1] + '' + cards[i - 1];
          } else if (sameSuit) cellVal = cards[rown - 1] + '' + cards[i - 1] + "s";else cellVal = cards[i - 1] + '' + cards[rown - 1] + "o";
          var style = "background-color: #D8D8D8 ;".concat(tdstyle);
          if (_this.state.hands.hasOwnProperty(cellVal) && _this.state.hands[cellVal] == 'Yes') {
            if (_this.state.play == 'ideal') {
              style = "background-color: #3BD989; ".concat(tdstyle);
            } else if (_this.state.play == 'actual') {
              style = "background-color: #EEEEEE; ".concat(tdstyle);
            }
          }
          if (_this.state.play == 'actual' && Object.keys(holeCards).length > 0) {
            index = holeCards.findIndex(function (holeCard) {
              return holeCard.cards === cellVal;
            });
            if (index != -1) {
              if (_this.state.hands[cellVal] == 'Yes') style = "background-color: #3BD989; ".concat(tdstyle);else if (_this.state.hands[cellVal] == 'No') style = "background-color: #f06E75; ".concat(tdstyle);
            }
          }
          return '<td style="' + style + '">' + cellVal + '</td>';
        });
      }
      return cells;
    };
    _this.state = {
      loading: false,
      tableData: [],
      play: _this.props.play,
      position: _this.props.position,
      holeCards: _this.props.holeCards,
      hands: _this.props.preFlopAggression ? [] : _this.props.hands[_this.props.position],
      imageSrc: null
    };
    _this.tableData();
    return _this;
  }
  _createClass(StartingHandChart, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.preFlopAggression) {
        this.tableData();
      } else {
        if (this.state.holeCards != nextProps.holeCards || this.state.play != nextProps.play || this.state.position != nextProps.position) {
          this.state.tableData = nextProps.tableData;
          this.state.play = nextProps.play;
          this.state.position = nextProps.position;
          this.state.holeCards = nextProps.holeCards;
          this.state.hands = nextProps.hands[nextProps.position];
          this.forceUpdate();
          this.tableData();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      // let Loading = this.props.Loading;
      return /*#__PURE__*/_react["default"].createElement("span", null, this.state.imageSrc && /*#__PURE__*/_react["default"].createElement("img", {
        "data-e2e": "missionPosImg",
        src: this.state.imageSrc,
        className: "table-starting-hand",
        alt: "Starting Hand Chart"
      }));
    }
  }]);
  return StartingHandChart;
}(_react["default"].Component);
var _default = StartingHandChart;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/Missions/StartingHandChart.js
 ** module id = 2380
 ** module chunks = 0
 **/